import React from 'react';
import { Alert, Box, Typography } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';

const LogoutNotification = () => {
  const { logoutMessage } = useAuth();

  if (!logoutMessage) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        p: 2,
      }}
    >
      <Alert 
        severity="warning" 
        sx={{ 
          maxWidth: 600, 
          mx: 'auto',
          boxShadow: 3,
        }}
      >
        <Typography variant="body1">
          {logoutMessage}
        </Typography>
      </Alert>
    </Box>
  );
};

export default LogoutNotification;

